import React from 'react';
import PageWrapper from './PageWrapper';
import EditableText from './EditableText';
import EditableImage from './EditableImage';

export default function AboutPage({ data, personName, pageNumber }) {
  const leversImage = data && data.leversImage;
  const leversImageWidth = data && data.leversImageWidth;
  const leversImageHeight = data && data.leversImageHeight;

  return (
    <PageWrapper pageNumber={pageNumber} personName={personName}>
      <EditableText
        as="h2"
        className="pdf-section-heading"
        path="aboutPage.sectionHeading"
        variant="inline"
        stripInlineWrap
      />

      <div className="about-intro-layout">
        <div className="about-intro-layout__text">
          <EditableText
            as="div"
            className="pdf-body-text-block"
            path="aboutPage.seekPerspectiveReports"
            variant="block"
          />
        </div>
        <div className="about-intro-layout__callout">
          <div className="about-intro-layout__callout-inner">
            <EditableText
              as="p"
              className="about-intro-layout__callout-headline"
              path="aboutPage.calloutHeadline"
              variant="inline"
              stripInlineWrap
            />
            <EditableText
              as="p"
              className="about-intro-layout__callout-body"
              path="aboutPage.calloutBody"
              variant="block"
              stripInlineWrap
            />
          </div>
        </div>
      </div>

      <div className="about-levers">
        <EditableText
          as="h3"
          className="about-levers__heading"
          path="aboutPage.leversHeading"
          variant="inline"
          stripInlineWrap
        />
        <EditableText
          as="p"
          className="about-levers__subtext"
          path="aboutPage.leversSubtext"
          variant="block"
          stripInlineWrap
        />
        <div className="about-levers__image">
          <EditableImage
            image={leversImage}
            width={leversImageWidth}
            height={leversImageHeight}
            imagePath="aboutPage.leversImage"
            widthPath="aboutPage.leversImageWidth"
            heightPath="aboutPage.leversImageHeight"
            defaultWidth={240}
            defaultHeight={120}
            maxHeight={300}
          />
        </div>
      </div>
    </PageWrapper>
  );
}
